import type { ClipboardEvent, KeyboardEvent } from "react"
import { Button } from "@/components/ui/button"

type VerificationCodeFormProps = {
  digits: string[]
  inputRefs: { current: Array<HTMLInputElement | null> }
  onDigitChange: (index: number, value: string) => void
  onKeyDown: (index: number, event: KeyboardEvent<HTMLInputElement>) => void
  onPaste: (event: ClipboardEvent<HTMLInputElement>) => void
  onVerify: () => void
}

export const VerificationCodeForm: React.FC<VerificationCodeFormProps> = ({
  digits,
  inputRefs,
  onDigitChange,
  onKeyDown,
  onPaste,
  onVerify,
}) => (
  <div className="space-y-3">
    <p className="text-sm text-center text-slate-600">Enter your 6-digit verification code</p>
    <div className="flex items-center justify-center gap-2">
      {digits.map((digit, index) => (
        <input
          key={index}
          ref={(element) => {
            inputRefs.current[index] = element
          }}
          type="text"
          inputMode="numeric"
          autoComplete="one-time-code"
          pattern="[0-9]*"
          maxLength={1}
          className="border rounded-md w-11 h-12 text-center text-lg font-semibold"
          value={digit}
          onChange={(e) => onDigitChange(index, e.target.value)}
          onKeyDown={(e) => onKeyDown(index, e)}
          onPaste={onPaste}
        />
      ))}
    </div>
    <Button onClick={onVerify} className="biogain-background-green cursor-pointer w-full">
      Verify code
    </Button>
  </div>
)